export const isFrozenSerializedAvailability = ({
	rowData,
	stateTable = {},
	field = {},
} = {}) =>
	Boolean(
		!field.isTransferredQuantity &&
			stateTable.isOriginTransaction &&
			stateTable.isTransactionFrozen &&
			(rowData?.is_serialized === true || rowData?.isSerialized === true),
	);

export const formatAmountInput = (value, coinSymbol) => {
	const formattedValue = String(value ?? '').replace(
		/\B(?=(\d{3})+(?!\d))/g,
		',',
	);
	return coinSymbol ? `${coinSymbol} ${formattedValue}` : formattedValue;
};
